export const getInitialName = (fullname) => {
  if (fullname) {
    const totalWord = fullname.split(' ').length
    const fullName = fullname.split('')

    // cek jumlah kata
    if (totalWord === 1) {
      const initials = fullName.shift().charAt(0)
      return initials.toUpperCase()
    }

    const initials = fullname.split(' ')[0][0] + fullname.split(' ')[1][0]
    return initials.toUpperCase()
  }

  return ''
}

export const formatDate = (date) => {
  const dateValue = new Date(date.split('/')[2], date.split('/')[1] - 1, date.split('/')[0])
  return dateValue.toLocaleDateString('id-ID', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}
